import React, { createContext, useState, useContext } from "react";

const PopupContext = createContext();

// Long descriptive text used for welcome and info popups
export const POPUP_LONG_TEXT = `Two opponents a and b take turns placing their pieces on the squares of the field. Moreover, each move adds a statement to the associated C, JavaScript, Java, Perl and even Python (pytest) program. When placing a figure on the main diagonal of the field, a negation operator is added. When placing a shape outside the main diagonal, a conditional jump operator is added. Each of the opponents has one variable $a and $b. At the beginning of the game $a = 0 and $b = 0. If, as a result of the program execution, $a is equal to $b, then a won, otherwise b. The looping loses immediately. In controversial situations, a Perl program can be copied into a Perl interpreter and executed for impartial judgment. For training, you can play with the computer by pressing the "random" or "computer" buttons for the opponent.
We all don't like the goto statement. However, we use do while and break to label. We have to use the conditional jump operator when testing deep recursion or spaghetti code in the frontend. Algorithmic chess teaches this.
Algorithmic chess is an intellectual game for the ability to read and build the logic of thinking and behavior to achieve a set goal in a competitive environment. In the 80s of the last century, it was proved that the logic of any program can be written by a combination of the negation and conditional jump operators. "IS and IF", "IS and IF" embody the philosophy of constructive knowledge. In the era of artificial intelligence, a mathematician with a computer is smarter than anyone. Who is the smartest mathematician? Algorithmic chess helps to determine this. Good Fight!`;

export const PopupProvider = ({ children }) => {
  // Build a JSX div from the long text so we render paragraphs inside the popup
  const initialContent = (
    <div>
      {POPUP_LONG_TEXT.split("\n\n").map((para, i) => (
        <p key={i}>{para}</p>
      ))}
    </div>
  );

  // Start the app with a persistent welcome popup that requires the user to press Start
  const [value, setValue] = useState({
    content: initialContent,
    persistent: true,
    startText: "Start",
  });
  const triggerPopup = (textOrObject) => setValue(textOrObject);
  const clearPopup = () => setValue();

  return (
    <PopupContext.Provider value={{ value, triggerPopup, clearPopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
export default PopupContext;
